import React from 'react';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { ValueProposition } from './components/ValueProposition';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Process } from './components/Process';
import { Trust } from './components/Trust';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-orange selection:text-white" data-id="element-0">
      <WhatsAppButton data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <ValueProposition data-id="element-5" />
        <Services data-id="element-6" />
        <Gallery data-id="element-7" />
        <WhyChooseUs data-id="element-8" />
        <Process data-id="element-9" />
        <Trust data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}